// extracted by mini-css-extract-plugin
export default {"root":"OptionsView_root__KyyVO","footer":"OptionsView_footer__UlExP"};